import { useQuery } from "@apollo/client";
import { Alert } from "@mui/material";
import { DateTime } from "luxon";
import { ReactElement } from "react";

import {
  GetLatestBudgetsQuery,
  GetLatestBudgetsQueryVariables,
} from "~frontend/__generated__/graphql";
import { GET_LATEST_BUDGETS } from "~frontend/graphql/budgets";

export default function BackdatedPricingBudgetWarning({
  effectiveDate,
}: {
  effectiveDate: DateTime | null;
}): ReactElement | null {
  const { loading, error, data } = useQuery<
    GetLatestBudgetsQuery,
    GetLatestBudgetsQueryVariables
  >(GET_LATEST_BUDGETS);

  if (effectiveDate && effectiveDate > DateTime.now()) {
    return null;
  }

  if (loading || error) {
    return null;
  }

  const budgets = data?.getLatestBudgets || [];
  const activeBudget = budgets.find(b => b.budget?.endDate === null);

  if (!activeBudget) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2, mx: 3 }}>
      <strong>Warning:</strong> You are adding a backdated pricing change to an
      organization with budgeting turned on. This pricing change will affect
      existing budgets and may block or un-block texting.
    </Alert>
  );
}
